import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 20px;
  display: flex;
  width: 100%;
  max-width: 260px;
  flex-direction: column;
  gap: 10px;
`;
